import { Box, TextField, IconButton, Tooltip, Typography } from "@mui/material"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import ClearIcon from "@mui/icons-material/Clear"
import { useLocalization } from "../../providers/LocalizationProvider"

/**
 * ActionableInputField
 *
 * A reusable input field with:
 * - Editable TextField
 * - Top-left clear button
 * - Top-right menu (three-dot) button
 *
 * Fully controlled by parent
 */
const ActionableInputField = ({
    value,
    onChange,
    onClear,
    onMenuClick,

    showClear = true,
    showMenu = true,

    clearDisabled = false,
    menuDisabled = false,

    textFieldProps = {},
    containerSx = {},
}) => {
    const hasValue = value !== undefined && value !== null && String(value).trim() !== ""
    const { voiceiiTags } = useLocalization()
    return (
        <Box
            className="e-actionable-input-container"
            sx={{
                ...containerSx,
            }}
        >
            <Box>
                <Typography className="e-asset-label">
                    {voiceiiTags(textFieldProps.label)}
                    {textFieldProps.required && <span style={{ color: "#d32f2f" }}>{" *"}</span>}
                </Typography>
                <TextField
                    className="e-input"
                    fullWidth
                    value={value}
                    onChange={onChange}
                    {...textFieldProps}
                />
            </Box>

            {/* MENU BUTTON (TOP-RIGHT) */}
            {showMenu && (
                <Tooltip title={voiceiiTags("More Actions")} arrow placement="top">
                    <IconButton
                        disabled={menuDisabled}
                        onClick={onMenuClick}
                        className="e-actionable-input-menu-btn"
                    >
                        <MoreVertIcon className="fs-6" />
                    </IconButton>
                </Tooltip>
            )}

            {/* CLEAR BUTTON (TOP-LEFT) */}
            {showClear && hasValue && (
                <Tooltip title={voiceiiTags("Clear Value")} arrow placement="top">
                    <IconButton
                        disabled={clearDisabled}
                        onClick={onClear}
                        className="e-actionable-input-clear-btn"
                    >
                        <ClearIcon className="fs-6" />
                    </IconButton>
                </Tooltip>
            )}
        </Box>
    )
}

export default ActionableInputField
